import { MinMaxFares } from '../../interfaces/Settings/MinMaxFares';

export const getDefaultMinMaxFares = (): MinMaxFares => ({
  minFareFirstOrder: 3,
  minFareSubsequentOrder: 1,
  maxFarePerOrder: 10,
  minFareFirstOrderLowerBound: 2.5,
  minFareFirstOrderUpperBound: 3,
});
